export default __webpack_public_path__ + "static/media/mia-profile.3a7bffe8.jpg";